export default __webpack_public_path__ + "static/media/device-card-skeleton.fef3667e.svg";